var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"twopage"},[_c('img',{staticClass:"background-img",attrs:{"src":"/assets/~/media/images/activity/film2505-prod/mob/kv.jpg"}})])
}]

export { render, staticRenderFns }